// extracted by mini-css-extract-plugin
var _1 = "ClientNotesFilter_chips__to+1z";
export { _1 as "chips" }
